import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { resetPassword, formatApiError } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/motion";
import { toast } from "sonner";
import { CheckCircle2, KeyRound } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const inputCls = "w-full min-h-[52px] rounded-2xl border border-shule-lineaccent bg-shule-base px-4 text-sm outline-none focus:border-shule-gold transition-colors";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Şifreler birbiriyle eşleşmiyor");
      return;
    }
    setLoading(true);
    try {
      const r = await resetPassword({ token, password });
      toast.success(r.message);
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Seo title="Yeni Şifre" path="/sifre-sifirla"  noindex />
      <div className="container-shule py-14 lg:py-24 flex justify-center">
        <Reveal className="w-full max-w-md">
          <div className="rounded-[2rem] border border-shule-line bg-shule-paper p-6 sm:p-8 shadow-[0_10px_30px_-10px_rgba(61,46,40,0.05)]">
            {!token ? (
              <div data-testid="reset-no-token" className="text-center py-6">
                <KeyRound className="w-12 h-12 mx-auto text-shule-taupe" />
                <h1 className="mt-4 font-serif text-2xl">Bağlantı eksik</h1>
                <p className="mt-3 text-sm text-shule-mocha">Bu sayfaya e-postandaki bağlantıyla gelmelisin.</p>
                <Link to="/giris" data-testid="reset-goto-login" className="btn-primary-shule mt-6 w-full">Girişe Dön</Link>
              </div>
            ) : done ? (
              <div data-testid="reset-success" className="text-center py-6">
                <CheckCircle2 className="w-12 h-12 mx-auto text-shule-gold" />
                <h1 className="mt-4 font-serif text-2xl">Şifren güncellendi</h1>
                <p className="mt-3 text-sm text-shule-mocha">Yeni şifrenle giriş yapabilirsin.</p>
                <Link to="/giris" data-testid="reset-success-login-button" className="btn-primary-shule mt-6 w-full">Giriş Yap</Link>
              </div>
            ) : (
              <form data-testid="reset-form" onSubmit={submit} className="space-y-4">
                <h1 className="font-serif text-2xl">Yeni şifreni belirle</h1>
                <div>
                  <label htmlFor="reset-password" className="text-sm font-semibold block mb-2">Yeni Şifre</label>
                  <input id="reset-password" data-testid="reset-password-input" type="password" required minLength={6}
                    className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="En az 6 karakter" />
                </div>
                <div>
                  <label htmlFor="reset-confirm" className="text-sm font-semibold block mb-2">Yeni Şifre (Tekrar)</label>
                  <input id="reset-confirm" data-testid="reset-confirm-input" type="password" required minLength={6}
                    className={inputCls} value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Aynı şifreyi tekrar yaz" />
                </div>
                {error && <p data-testid="reset-error" className="text-sm text-red-800 bg-red-50 border border-red-200 rounded-xl px-4 py-3">{error}</p>}
                <button data-testid="reset-submit-button" disabled={loading} className="btn-primary-shule w-full !min-h-[52px] disabled:opacity-40">
                  {loading ? "Güncelleniyor…" : "Şifremi Güncelle"}
                </button>
              </form>
            )}
          </div>
        </Reveal>
      </div>
    </>
  );
}
